<template lang="slm">
.column.Issue.is-3-desktop.is-6-tablet.is-12-mobile :style="{display: 'flex'}"
  router-link :to="issue.issue.slug.current" class="IssueList-card"
  	h3.title {{issue.issue.title}}
  	p style="font-size: 18px;" {{issue.lead}}
  	.imgContainter
      image-source :source="issue.issue.image.asset.url" :widths="widths" :ratio=1.78 :alt="issue.title"
      <!-- :params="&fm=png&fit=fill" -->
</template>

<script>
import ImageSource from '@/components/ImageSource'

export default {
  data () {
    return {
      widths: [800, 800, 800],
      slug: ''
    }
  },
  components: {
    'image-source': ImageSource
  },
  props: ['issue']
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/IssueCard.vue